import { PostApi } from "../pages/DashBoard/partials/Feed/types/types";

interface NewPostDataProps {
  post: PostApi;
  heading: string;
  content: string;
  documentFile?: File;
  imageFiles?: File[];
  publish_at?: string;
}

export const createUpdatedPostData = ({post, heading, content, documentFile, imageFiles, publish_at}: NewPostDataProps) => {
  const postFormData = new FormData();

  const updatedPost = {
    ...post,
    heading,
    content,
    updated_at: new Date().toISOString(),
  };

  Object.entries(updatedPost).forEach(([key, value]) => {
    if (key === "publish_at" || key === "published_at" || key === "status" || key === "send_sms_on_publish") {
      return;
    }
    if (value === undefined || value === null) return;
    if (typeof value === "object") return;
    postFormData.append(key, String(value));
  });

  if (publish_at) {
    postFormData.append("publish_at", publish_at);
  }

  if (documentFile) {
    postFormData.append('document', documentFile);
  }

  if (imageFiles?.length) {
    imageFiles.forEach((file) => {
      postFormData.append(`images`, file);
    });
  }
  
  return postFormData;
}
